class AbsorbencySwiper {
  constructor() {
    this.sliderInstance = null;
    this.sliderWrapper = null;
    this.container = document.querySelector('.absorbency-options');
    this.breakpoint = 768; 
    
    this.init();
    this.handleResize();
  }

  init() {
    if (this.isMobile()) {
      this.initSlider();
    }
  }

  isMobile() {
    return window.innerWidth < this.breakpoint;
  }

  initSlider() {
    if (this.sliderInstance || !this.container) return;

    this.container.classList.add('swiper-wrapper');
    
    const swiperContainer = document.createElement('div');
    swiperContainer.className = 'swiper absorbency-swiper';
    
    this.container.parentNode.insertBefore(swiperContainer, this.container);
    swiperContainer.appendChild(this.container);
    
    this.sliderWrapper = swiperContainer;
    
    const options = this.container.querySelectorAll('absorbency-option');
    options.forEach(option => {
      option.classList.add('swiper-slide');
    });

    this.sliderOptions = {
      slidesPerView: 'auto',
      speed: 500,
      grabCursor: true,
      allowTouchMove: true,
      loop: false,
      threshold: 2,
      breakpoints: {
        320: {
          slidesPerView: 2,
        },
        375: {
          slidesPerView: 2,
        },
        425: {
          slidesPerView: 2,
        }
      },
    //   on: {
    //     init: this.handleSliderInit.bind(this),
    //   },
    };

    if (window.FoxTheme && window.FoxTheme.Carousel) {
      this.sliderInstance = new window.FoxTheme.Carousel(
        this.sliderWrapper, 
        this.sliderOptions,
        []
      );
      this.sliderInstance.init();
    } else {
      console.warn('FoxTheme.Carousel not available, falling back to native Swiper');
      if (typeof Swiper !== 'undefined') {
        this.sliderInstance = {
          slider: new Swiper('.absorbency-swiper', this.sliderOptions)
        };
      }
    }
  }


  destroySlider() {
    if (!this.sliderInstance) return;

    if (this.sliderInstance.slider && this.sliderInstance.slider.destroy) {
      this.sliderInstance.slider.destroy();
    }
    this.sliderInstance = null;

    const swiperContainer = document.querySelector('.absorbency-swiper');
    const options = this.container.querySelectorAll('absorbency-option');
    
    if (swiperContainer) {
      this.container.classList.remove('swiper-wrapper');
      options.forEach(option => {
        option.classList.remove('swiper-slide');
      });

      swiperContainer.parentNode.insertBefore(this.container, swiperContainer);
      swiperContainer.remove();
    }

    this.sliderWrapper = null;
  }

  handleResize() {
    let resizeTimer;
    
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const shouldShowSlider = this.isMobile();
        const sliderExists = this.sliderInstance !== null;

        if (shouldShowSlider && !sliderExists) {
          this.initSlider();
        } else if (!shouldShowSlider && sliderExists) {
          this.destroySlider();
        }
      }, 100);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.FoxTheme && window.FoxTheme.Carousel) {
    new AbsorbencySwiper();
  } else if (typeof Swiper !== 'undefined') {
    console.warn('Using Swiper fallback - FoxTheme.Carousel not available');
    new AbsorbencySwiper();
  } else {
    console.error('Neither FoxTheme.Carousel nor Swiper is available. Please check if the required libraries are loaded.');
  }
});

window.AbsorbencySwiper = AbsorbencySwiper;